import { Box, Grid } from "@mui/system";
import { Autocomplete, IconButton, TextField, Typography } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import SearchIcon from "@mui/icons-material/Search";

import WithoutFtdAndNetRevTable from "./WithoutFtdAndNetRevTable";

const tableHeadings = {
  brand_name: "Brand Name",
  brand_id: "Brand ID",
  brand_action_date: "Brand Action Date",
  click_out: "Click Out",
};
export const rows = [
  {
    brand_name: "BetVictor Sport UK",
    brand_id: "2319",
    brand_action_date: "21/04/2026",
    click_out: "100",
  },
  {
    brand_name: "BBetVictor Sport UK",
    brand_id: "2319",
    brand_action_date: "21/04/2026",
    click_out: "137",
  },
];

const WithoutFtdAndNetRev = () => {
  const brandName = [
    { label: "Brand 01" },
    { label: "Brand 02" },
    { label: "Brand 03" },
    { label: "Brand 04" },
  ];

  return (
    <>
      <Grid
        container
        spacing={2}
        alignItems="center"
        px={2}
        py={1.5}
        sx={{ borderTop: "1px solid #0000001F" }}
      >
        <Grid size={8}>
          <Typography variant="body1" fontSize={18}>
            Brands without FTD & NetRev in the Last 60 Days
          </Typography>
        </Grid>
        <Grid size={4}>
          <Box display={"flex"} alignItems={"end"} justifyContent={"flex-end"}>
            <Autocomplete
              id="assetOrSiteName"
              disablePortal
              options={brandName}
              getOptionLabel={(option) => option.label}
              size="small"
              sx={{ pt: "8px", width: "275px" }}
              renderInput={(params) => (
                <TextField
                  color="secondary"
                  {...params}
                  required
                  placeholder="Search Brand Name or choose from the list"
                  label="Brand Name"
                  InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                      <>
                        <SearchIcon
                          sx={{ fontSize: 20, mr: 1, color: "text.secondary" }}
                        />
                        {params.InputProps.startAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
            <IconButton
              aria-label="fingerprint"
              color="secondary"
              sx={{ ml: 2 }}
            >
              <DownloadIcon />
            </IconButton>
          </Box>
        </Grid>
      </Grid>
      <WithoutFtdAndNetRevTable tableHeadings={tableHeadings} rows={rows} />
    </>
  );
};

export default WithoutFtdAndNetRev;
